import { render, staticRenderFns } from "./tab-bar.vue?vue&type=template&id=2f032f4b"
import script from "./tab-bar.vue?vue&type=script&lang=js"
export * from "./tab-bar.vue?vue&type=script&lang=js"
import style0 from "./tab-bar.vue?vue&type=style&index=0&id=2f032f4b&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports